// extracted by mini-css-extract-plugin
export default {"column":"SuperAdminOrderGeneration_column__FWLfy","row":"SuperAdminOrderGeneration_row__Qhsld","primaryButton":"SuperAdminOrderGeneration_primaryButton__7rkoh"};